import { render, staticRenderFns } from "./TermsHub.vue?vue&type=template&id=0d01622d&scoped=true"
import script from "./TermsHub.vue?vue&type=script&lang=js"
export * from "./TermsHub.vue?vue&type=script&lang=js"
import style0 from "./TermsHub.vue?vue&type=style&index=0&id=0d01622d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01622d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d01622d')) {
      api.createRecord('0d01622d', component.options)
    } else {
      api.reload('0d01622d', component.options)
    }
    module.hot.accept("./TermsHub.vue?vue&type=template&id=0d01622d&scoped=true", function () {
      api.rerender('0d01622d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/TermsHub.vue"
export default component.exports